import { useFeatureGoogleAnalytics } from '../../../../shared_app/hooks/useFeatureGoogleAnalytics';
var WD_EVENT_CATEGORY = 'WeeklyDashboard';
var WeeklyDashboardEvents = {
    pageView: WD_EVENT_CATEGORY + "_Open",
    datepickerClick: "AB_" + WD_EVENT_CATEGORY + "_Calendar_Open",
    inactiveStudentsHover: "AB_" + WD_EVENT_CATEGORY + "_InactiveStudents_Hover",
    onlineStudentsHover: WD_EVENT_CATEGORY + "_CurrentlyOnline_Hover",
    studentsActivityDiagramHover: WD_EVENT_CATEGORY + "_ActiveStudentsByDay_Hover",
    timeTargetCompletedHover: "AB_" + WD_EVENT_CATEGORY + "_TimeFraction_Hover",
    taskTargetCompletedHover: "AB_" + WD_EVENT_CATEGORY + "_TaskFraction_Hover",
    timeBarHoverNotStarted: "AB_" + WD_EVENT_CATEGORY + "_TimeBar_NS_Hover",
    timeBarHoverStarted: "AB_" + WD_EVENT_CATEGORY + "_TimeBar_S_Hover",
    timeBarHoverHalfway: "AB_" + WD_EVENT_CATEGORY + "_TimeBar_Hw_Hover",
    timeBarHoverCompleted: "AB_WD_Target_TimeBar_Completed_Hover",
    taskBarHoverNotStarted: "AB_WD_Target_TaskBar_NotStarted_Hover",
    taskBarHoverStarted: "AB_WD_Target_TaskBar_Started_Hover",
    taskBarHoverHalfway: "AB_WD_Target_TaskBar_Halfway_Hover",
    taskBarHoverCompleted: "AB_WD_Target_TaskBar_Completed_Hover",
    studentTimeTargetHover: WD_EVENT_CATEGORY + "_Student_TimeTarget_Hover",
    studentTaskTargetHover: WD_EVENT_CATEGORY + "_Student_TaskTarget_Hover",
    studentReportLinkHover: "AB_" + WD_EVENT_CATEGORY + "_StudentReport_Hover",
    studentReportLinkClick: "AB_" + WD_EVENT_CATEGORY + "_StudentReport_Click",
    studentDayHover: "AB_" + WD_EVENT_CATEGORY + "_DailyTimeSquare_Hover",
    studentNameHover: WD_EVENT_CATEGORY + "_Student_Name_Hover",
    studentNameCellClick: "AB_" + WD_EVENT_CATEGORY + "_StudentMenu_Arrow_Open",
    studentRowExpand: WD_EVENT_CATEGORY + "_StudentMenu_Line_Open",
    struggleStudentNameCellClick: "AB_" + WD_EVENT_CATEGORY + "_StudentMenuS_Arrow_Open",
    struggleStudentRowExpand: WD_EVENT_CATEGORY + "_StudentMenuS_Line_Open",
    cardClick: WD_EVENT_CATEGORY + "_StudentMenu_OpenCard_NoStruggle",
    struggleCardClick: WD_EVENT_CATEGORY + "_StudentMenu_OpenCard_Struggle",
    struggleStudentLinkClick: WD_EVENT_CATEGORY + "_StudentName_Struggle_Click",
    studentLinkClick: WD_EVENT_CATEGORY + "_StudentName_Click",
    struggleStudentIconHover: WD_EVENT_CATEGORY + "_StudentName_StruggleIcon_Hover",
    studentCardIconHover: WD_EVENT_CATEGORY + "_StudentMenu_StruggleIcon_Hover",
    studentStruggleFilterEnable: WD_EVENT_CATEGORY + "_StudentMenu_FilterStuggle",
    stuckHelpIconHover: WD_EVENT_CATEGORY + "_Stuck_Tooltip_Hover",
    stuckTooltipLinkClick: WD_EVENT_CATEGORY + "_Stuck_Tooltip_Link_Click",
    stuckNameClick: "AB_" + WD_EVENT_CATEGORY + "_Stuck_Name_Click",
    stuckOpenCardClick: WD_EVENT_CATEGORY + "_Stuck_OpenCard",
    stuckTimeHover: WD_EVENT_CATEGORY + "_Stuck_Time_Hover",
    stuckShowAllClick: WD_EVENT_CATEGORY + "_Stuck_ShowAll_Click",
    stuckShowLessClick: WD_EVENT_CATEGORY + "_Stuck_Hide_Click",
    assignmentLinkClick: WD_EVENT_CATEGORY + "_Assigment",
    assignmentCardClick: WD_EVENT_CATEGORY + "_Assigment_OpenCard",
    struggleAssignmentCardClick: WD_EVENT_CATEGORY + "_Assigment_OpenCard_Struggle",
    struggleAssignmentCardIconHover: WD_EVENT_CATEGORY + "_Assigment_StruggleIcon_Hover",
};
var useWeeklyDashboardAnalytics = function () {
    return useFeatureGoogleAnalytics(WD_EVENT_CATEGORY);
};
export { useWeeklyDashboardAnalytics, WeeklyDashboardEvents };
